<div
  [ngClass]="{
    input: !(formControl.invalid && formControl.touched),
    'input-error': formControl.invalid && formControl.touched
  }"
>
  <label class="input-label-item" for="{{ for }}">{{ label }}</label>
  <input
    type="date"
    class="input-head-item"
    placeholder="{{ label }}"
    [formControl]="formControl"
  />
  @if (formControl.invalid && formControl.touched) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error">Este campo es requerido</div>
      }
    </div>
  }
  @if (helpLabel) {
    <div class="input-help-label">{{ helpLabel }}</div>
  }
</div>
